import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { FileTypeResponse } from "../../api-models/response/FileTypeResponse";
import { IVideo } from "../../api-models/response/inspection/InspectionDetailsResponse";

export const emptyVideo: IVideo = {
  id: 0,
  type: {id: 0, name: ""},
  name: "",
  location: "",
  contentType: "",
  url: "",
  urlForHtml5: "",
  uploadedBy: {id: 0, isDeleted: false, name: ""},
  uploadedDate: new Date(),
  size: 0,
  isConverted: false,
  conversionWasSuccessful: false,
  conversionErrorMessage: "",
  analysisSuccessfullyDone: false,
  segmentationSuccessfullyDone: false
}

export class Video implements IVideo {
  id: number;
  type: FileTypeResponse;
  name: string;
  location: string;
  contentType: string;
  url: string;
  urlForHtml5: string;
  uploadedBy: NameEntityResponse;
  uploadedDate: Date;
  size: number;
  isConverted: boolean;
  conversionWasSuccessful: boolean;
  conversionErrorMessage: string;
  analysisSuccessfullyDone: boolean;
  segmentationSuccessfullyDone: boolean;

  constructor(video: IVideo) {
    this.id = video.id;
    this.type = video.type;
    this.name = video.name;
    this.location = video.location;
    this.contentType = video.contentType;
    this.url = video.url;
    this.uploadedBy = video.uploadedBy;
    this.uploadedDate = video.uploadedDate;
    this.size = video.size;
    this.urlForHtml5 = video.urlForHtml5;
    this.isConverted = video.isConverted;
    this.conversionErrorMessage = video.conversionErrorMessage;
    this.conversionWasSuccessful = video.conversionWasSuccessful;
    this.analysisSuccessfullyDone = video.analysisSuccessfullyDone;
    this.segmentationSuccessfullyDone = video.segmentationSuccessfullyDone;
  }

  get videoUrl(): string {
    return this.urlForHtml5 || this.url;
  }

  get isAvailable(): boolean {
    return this.isConverted && this.conversionWasSuccessful;
  }

  get isConverting(): boolean {
    return !this.isConverted;
  }

  get conversionFailed(): boolean {
    return this.isConverted && !this.conversionWasSuccessful;
  }

  get conversionNotAvailable(): boolean {
    return this.conversionFailed || this.isConverting;
  }
}
